export default __webpack_public_path__ + "static/media/internationales_umfeld.ce90d768.svg";